import Calculator from "./components/calculator/Calculator";
import "./App.css";

function App() {
  return (
      <div className="window">
        <Calculator />
      </div>
  );
}

export default App;
